// src/components/Login.tsx
import React, { useState } from 'react';

interface LoginProps {
    onLogin: (username: string) => void;
    onLogout: () => void;
    isLoggedIn: boolean;
}

const Login: React.FC<LoginProps> = ({ onLogin, onLogout, isLoggedIn }) => {
    const [username, setUsername] = useState<string>('user1');
    const [password, setPassword] = useState<string>('password');

    const handleLogin = () => {
        if (username !== '' && password.toLocaleLowerCase() === 'password') {
            onLogin(username);
        } else {
            alert('Invalid username or password');
        }
    };

    return (
        <div className="login-container">
            {isLoggedIn ? (
                <div className="login-info">
                    <span>Logged in as: {username}</span>
                    <button className="logout-button" onClick={onLogout}>
                        Logout
                    </button>
                </div>
            ) : (
                <>
                    <input
                        type="text"
                        placeholder="Username"
                        className="styled-input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        className="styled-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button className="login-button" onClick={handleLogin}>
                        Login
                    </button>
                </>
            )}
        </div>
    );
};

export default Login;
